import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { BrandingContext } from './branding-context'

export function useBranding() {
  const context = useContext(BrandingContext)

  if (!context) {
    throw new Error('useBranding must be used within BrandingProvider')
  }

  return context
}

export function useShellBrandName(portal: 'admin' | 'user') {
  const { t } = useTranslation('shell')
  const {
    settings: { hasCustomTitle, title },
  } = useBranding()

  if (hasCustomTitle) {
    return title
  }

  return portal === 'admin' ? t('brand.admin') : t('brand.user')
}

export function useHubAgentName() {
  return useBranding().settings.hubAgentName
}

export function useHubAgentWelcomeTitle() {
  return useBranding().settings.hubAgentWelcomeTitle
}
